import { useEffect, useState } from 'react';
import { Maximize, Minimize } from 'lucide-react';
import { useT } from '../app/preferences.ts';

/** Toggles browser full screen for the whole page. Hidden where the browser cannot do it (e.g. iPhone). */
export function FullscreenButton() {
  const t = useT();
  const [active, setActive] = useState(() => Boolean(document.fullscreenElement));

  useEffect(() => {
    const sync = () => setActive(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', sync);
    return () => document.removeEventListener('fullscreenchange', sync);
  }, []);

  if (!document.fullscreenEnabled) return null;

  const toggle = () => {
    if (document.fullscreenElement) void document.exitFullscreen().catch(() => undefined);
    else void document.documentElement.requestFullscreen({ navigationUI: 'hide' }).catch(() => undefined);
  };

  const label = t(active ? 'game.exitFullscreen' : 'game.fullscreen');
  return (
    <button type="button" className="btn btn-sm fullscreen-btn" onClick={toggle} aria-pressed={active} title={label}>
      {active ? <Minimize size={18} /> : <Maximize size={18} />}
      <span>{label}</span>
    </button>
  );
}
